export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const BALANCE_SUCCESS = "BALANCE_SUCCESS";
export const LOGOUT = "LOGOUT";
export const EXPOSURE_AMOUNT = "EXPOSURE_AMOUNT";
export const PLAYER_PROFILE = "PLAYER_PROFILE";
